export var SchemaFormat;
(function (SchemaFormat) {
    SchemaFormat["INT32"] = "int32";
    SchemaFormat["INT64"] = "int64";
    SchemaFormat["FLOAT"] = "float";
    SchemaFormat["DOUBLE"] = "double";
    SchemaFormat["BYTE"] = "byte";
    SchemaFormat["BINARY"] = "binary";
    SchemaFormat["DATE"] = "date";
    SchemaFormat["DATE_TIME"] = "date-time";
    SchemaFormat["PASSWORD"] = "password";
    // non-standard
    SchemaFormat["UUID"] = "uuid";
    SchemaFormat["TEXT"] = "text";
    SchemaFormat["URL"] = "url";
    SchemaFormat["DOWNLOAD"] = "download";
    SchemaFormat["AUTH_DOWNLOAD"] = "auth-download";
    SchemaFormat["CURRENCY"] = "currency";
    SchemaFormat["DETAIL"] = "detail";
    SchemaFormat["EMAIL"] = "email";
    SchemaFormat["PDF"] = "pdf";
    SchemaFormat["PREFORMATTED"] = "preformatted";
    SchemaFormat["TABLE"] = "table";
    SchemaFormat["LICENSE_PLATE"] = "license-plate";
})(SchemaFormat || (SchemaFormat = {}));
export var SchemaType;
(function (SchemaType) {
    SchemaType["STRING"] = "string";
    SchemaType["NUMBER"] = "number";
    SchemaType["INTEGER"] = "integer";
    SchemaType["BOOLEAN"] = "boolean";
    SchemaType["OBJECT"] = "object";
    SchemaType["ARRAY"] = "array";
    SchemaType["ANY"] = "any";
    SchemaType["NULL"] = "null";
})(SchemaType || (SchemaType = {}));
export var Method;
(function (Method) {
    Method["GET"] = "get";
    Method["PUT"] = "put";
    Method["POST"] = "post";
    Method["DELETE"] = "delete";
    Method["OPTION"] = "options";
    Method["HEAD"] = "head";
    Method["PATCH"] = "patch";
    Method["TRACE"] = "trace";
})(Method || (Method = {}));
